// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockTitle_wrapper__Dg33c","title":"BlockTitle_title__ieNUb","border":"BlockTitle_border__1ZOvP"};